export const mockData = {
  tools: [
    {
      id: 1,
      name: 'BIN Generator',
      label: 'GEN',
      description: 'Gere números de cartão válidos com algoritmo Luhn para testes',
      icon: 'zap',
      color: 'orange',
      borderColor: 'border-t-orange-500',
      bgColor: 'bg-orange-500',
      link: '/gen'
    },
    {
      id: 2,
      name: 'Card Checker',
      label: 'CHECK LIVE',
      description: 'Verifique cartões em tempo real, um por um com resultados instantâneos',
      icon: 'shield-check',
      color: 'cyan',
      borderColor: 'border-t-cyan-500',
      bgColor: 'bg-cyan-500',
      link: '/check-live'
    },
    {
      id: 3,
      name: 'Stripe Connector',
      label: 'CHECK STRIPE',
      description: 'Validação via Stripe Connector v3 com sua própria chave',
      icon: 'terminal',
      color: 'purple',
      borderColor: 'border-t-purple-500',
      bgColor: 'bg-purple-500',
      link: '/check-stripe'
    }
  ],
  stats: [
    { value: '10K+', label: 'Gerações', color: 'text-orange-500' },
    { value: '99.9%', label: 'Uptime', color: 'text-cyan-500' },
    { value: '50+', label: 'Países', color: 'text-purple-500' },
    { value: '24/7', label: 'Online', color: 'text-yellow-500' }
  ],
  footerLinks: {
    tools: [
      { name: 'Generator', link: '/gen' },
      { name: 'Check Live', link: '/check-live' },
      { name: 'Check Stripe', link: '/check-stripe' }
    ],
    resources: [
      { name: 'Articles', link: '/artigos' },
      { name: 'FAQ', link: '/faq' },
      { name: 'About', link: '/about' },
      { name: 'Contact', link: '/contact' }
    ],
    legal: [
      { name: 'Terms', link: '/terms' },
      { name: 'Privacy', link: '/privacy' }
    ]
  },
  securityFeatures: [
    'Criptografia de ponta a ponta',
    'Infraestrutura global distribuída',
    'Conformidade com padrões PCI-DSS'
  ]
};
